import { TZDate } from '@date-fns/tz'
import { format } from 'date-fns'

const PACIFIC_TIMEZONE = 'America/Los_Angeles'

/**
 * Converts Date objects to ISO string with PST/PDT offset for backend submission.
 */
export const formatDateForBackend = (date: Date, time: Date): string => {
  // Extract date/time components, ignoring the browser's timezone
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const hours = time.getHours()
  const minutes = time.getMinutes()

  // Create a TZDate in Pacific timezone with the extracted components
  const pstDate = new TZDate(
    year,
    month,
    day,
    hours,
    minutes,
    0,
    0,
    PACIFIC_TIMEZONE
  )

  // Format using date-fns, TZDate handles the timezone automatically
  return format(pstDate, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
}

/**
 * Converts UTC ISO string from backend to Date object that displays as PST/PDT.
 */
export const parseUTCToPST = (utcString: string): Date => {
  // Parse the UTC string and convert to Pacific timezone using TZDate
  const pstDate = new TZDate(utcString, PACIFIC_TIMEZONE)

  // Extract PST time components
  const year = pstDate.getFullYear()
  const month = pstDate.getMonth()
  const day = pstDate.getDate()
  const hours = pstDate.getHours()
  const minutes = pstDate.getMinutes()

  // Create a Date object with these components in local timezone
  return new Date(year, month, day, hours, minutes, 0, 0)
}
